import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { connect as connectFormik } from 'formik';
import { domainActions } from '../../../store/domainStore';
import { hasPermission } from '../../../store/apiWrapper';
import { withLocalize, Translate } from 'react-localize-redux';
import BbCheckbox from '../../styling/bbFormikCheckbox';
import BbInput from '../../styling/bbInput';
import BbPopover from "../../common/popover";
import classnames from 'classnames';
import CustomTooltip from "../../common/customTooltip";
import Message from '../../common/message';
import NavigationRow from '../../layoutItems/navigationRow';
import PopupMultiSelectButton from '../../common/popupMultiSelectButton';
import PortfolioNotificationReceivers from './portfolioNotificationReceivers';
import Widget from '../../common/widget';
import { PORTFOLIO_TYPES } from '../monitoringConstants';

import './createSection.scss';

const DOMAIN = "monitored-events-dictionary";
const M_ACTIVITY = {
    active: "active",
    inactive: "inactive"
};

class MonitoringSettingsSection extends React.Component {
    state = {
        monitoredEvents: null,
        invalidReceivers: {}
    };

    render() {
        const saveDisabled = this.props.formik.values.monitoringSettings.active &&
            this.props.formik.values.monitoringSettings.events &&
            this.props.formik.values.monitoringSettings.events.all.length < 1;
        return (
            <Widget className="create-portfolio-widget" header="Monitoring.Create.MonitoringSettings" initialExpanded={true}>
                {this.renderMonitoringActivityInput()}
                {Object.keys(this.state.invalidReceivers).length > 0 && <div className='columns'>
                    <div className='column is-12'>
                        <Message type="error" message={`${this.props.translate("Common.InvalidEmail")}:`}>
                            <ul>
                                {Object.keys(this.state.invalidReceivers).map(k => <li>{this.state.invalidReceivers[k]}</li>)}
                            </ul>
                        </Message>
                    </div>
                </div>}
                {this.props.formik.values.monitoringSettings.active &&
                    <div>
                        <div className="columns column is-12" style={{ display: 'inline' }}>
                            <div>
                                <BbCheckbox name="monitoringSettings.enabledNotifications"
                                    label={this.props.translate("Monitoring.Create.EnableNotification")}
                                    id="enabledNotifications"
                                    disabled={this.props.sharingRole !== 0}
                                />
                            </div>
                            {this.props.formik.values.monitoringSettings.enabledNotifications &&
                                <div style={{ marginLeft: '1em' }}>
                                    <BbCheckbox name="monitoringSettings.emptyNotifications"
                                        label={this.props.translate("Monitoring.Create.EmptyNotifications")}
                                        id="emptyNotifications"
                                        disabled={this.props.sharingRole !== 0} />
                                </div>}
                        </div>
                        {this.props.formik.values.monitoringSettings.enabledNotifications &&
                            <PortfolioNotificationReceivers sharingRole={this.props.sharingRole}
                                addErrorMessage={this.addErrorMessage}
                                validateEmail={this.validateEmail}
                                disabled={!this.props.formik.values.monitoringSettings.enabledNotifications}
                            />
                        }
                        {this.state.monitoredEvents && <div className="columns">
                            <div className="column is-11">
                                <BbInput type='custom' label={this.props.translate('Monitoring.Create.Events')}
                                    placeholder={{ type: 'column' }} custom={
                                        <PopupMultiSelectButton
                                            title={this.props.translate("Monitoring.Create.Events")}
                                            customDomain={this.state.monitoredEvents}
                                            popupSize='large'
                                            selection={this.props.formik.values.monitoringSettings.events}
                                            hasRadioButtons={true}
                                            handleChange={(all, parent) => {
                                                this.props.formik.setFieldValue('monitoringSettings.events', { all: all, parent: parent });
                                            }}
                                            readOnly={this.props.sharingRole > 1}
                                        />
                                    }
                                />
                            </div>
                        </div>}
                    </div>
                }
                <NavigationRow justify="flex-end">
                    {this.props.sharingRole <= 1 &&
                        <BbPopover
                            content={this.props.translate('Monitoring.Create.SelectEventTypes')}
                            placement="top"
                            targetId='btnSaveMonitoringSettings'
                            toggleOnEvent={saveDisabled ? "toggleOnMouse" : "toggleNever"}
                        >
                            <div id="btnSaveMonitoringSettings">
                                <button onClick={() => this.onSubmit()}
                                    className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                                    style={{ cursor: saveDisabled ? "not-allowed" : "pointer" }}
                                    disabled={saveDisabled}
                                >
                                    <Translate id="Common.Button.Save" />
                                </button>
                            </div>
                        </BbPopover>
                    }
                </NavigationRow>
            </Widget>
        );
    }

    componentDidMount() {
        this.getMonitoredEvents();
    }

    componentDidUpdate() {
        if (!this.state.monitoredEvents && this.props.domain[DOMAIN].requestResult && !this.props.domain[DOMAIN].isRequesting)
            this.getMonitoredEvents()
    }

    renderMonitoringActivityInput = () => {
        const input = {
            value: {
                [M_ACTIVITY.active]: 1,
                [M_ACTIVITY.inactive]: 2
            },
            checked: {
                [M_ACTIVITY.active]: this.props.formik.values.monitoringSettings.active,
                [M_ACTIVITY.inactive]: !this.props.formik.values.monitoringSettings.active
            },
            label: {
                [M_ACTIVITY.active]: 'Monitoring.Overview.Active',
                [M_ACTIVITY.inactive]: 'Monitoring.Overview.Inactive'
            },
        };

        return (
            <div className="columns">
                <div className="column is-narrow bb-input-label-column">
                    <div style={{ display: "flex", alignItems: "center", "height": "100%" }}>
                        {this.props.translate("Monitoring.Overview.Monitoring")}
                    </div>
                </div>
                <div className="column is-8">
                    <div className="settings-item">
                        <div className="settings-row">
                            <div id="tooltipMonitoring" className={classnames("settings-selector", { "disabled": this.props.sharingRole !== 0 })}
                                style={{ pointerEvents: this.monitoringEnabled() ? "inherit" : "inherit" }}>
                                {Object.keys(input.value).map(j => (
                                    <React.Fragment key={j}>
                                        <span data-active={input.checked[j]}
                                            onClick={() => { if (this.props.sharingRole === 0 && this.monitoringEnabled()) this.props.formik.setFieldValue('monitoringSettings.active', j === M_ACTIVITY.active) }}
                                        >
                                            {input.label ? this.props.translate(input.label[j]) : ""}
                                        </span>
                                    </React.Fragment>
                                ))}

                            </div>
                            {!this.monitoringEnabled() &&
                                <CustomTooltip textAlign="right" placement='right'
                                    id="tooltipMonitoring" text={this.props.translate("Monitoring.Overview.Tooltip")} hideIcon delay={{ "show": '0', "hide": '0' }} innerClassName='tooltipSection'>
                                </CustomTooltip>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    onSubmit = () => {
        const invalidReceivers = {};
        this.props.formik.values.monitoringSettings.notificationReceivers.forEach((e, i) => {
            if (!this.validateEmail(e))
                invalidReceivers[i] = e;
        });

        this.setState({ invalidReceivers: invalidReceivers })
        if (Object.keys(invalidReceivers).length === 0) {
            this.setState({ insertedReceivers: [] });
            this.props.onSubmit();
        }
    }

    validateEmail = (email) => {
        const expression = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)/i;
        return expression.test(email.toLowerCase())
    }

    addErrorMessage = (invalidReceiver) => {
        this.setState({ invalidReceivers: invalidReceiver });
    }

    getMonitoredEvents = () => {
        var dom = [];
        for (var i = 0; i < this.props.domain[DOMAIN].requestResult.length; i++) {
            var d = Object.assign({}, this.props.domain[DOMAIN].requestResult[i]);
            d.children = d.children.filter((ch) => { return ch.orderId == this.props.type });
            if (this.props.isFirstLevel === true)
                d.children = d.children.filter((ch) => { return ch.value !== "C_RS" });
            if (d.children.length > 0)
                dom.push(d);
        }
        this.setState({ monitoredEvents: dom });
    }

    monitoringEnabled = () => {
        if (this.props.type === PORTFOLIO_TYPES.companyCz || this.props.type === PORTFOLIO_TYPES.companySk)
            return hasPermission(null, "MonitoringSubjectsRole");
        if (this.props.type === PORTFOLIO_TYPES.cadastreSk)
            return hasPermission(null, "MonitoringCadastreRole");
        if (this.props.type === PORTFOLIO_TYPES.personCz || this.props.type === PORTFOLIO_TYPES.personSk)
            return hasPermission(null, "MonitoringPersonsRole");
        return false;
    }
}

export default withLocalize(connectFormik(connect(
    state => ({ domain: state.domain }),
    dispatch => bindActionCreators(domainActions, dispatch),
)(MonitoringSettingsSection)));